import React from "react";

export default function PhoneStaticMask(props) {

    let formatted = String(props.phone).replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, "($1) $2-$3");

    return <span>{formatted}</span>;

}